var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade-fast" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            class: [
              "streak-popup-overlay",
              { "streak-popup-mobile": _vm.isMobile }
            ],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$emit("should-close")
              }
            }
          },
          [
            _c(
              "div",
              {
                class: [
                  "streak-popup",
                  {
                    "streak-popup-mobile": _vm.isMobile,
                    "streak-popup-user-home": !_vm.hideCalendar,
                    celebration: _vm.notificationType === "newstreak",
                    "in-streak-charge-experiment": _vm.isStreakChargesEnabled
                  }
                ],
                attrs: { id: "streak-popup", "data-testid": "streak_popup" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _vm.isMobile
                  ? _c(
                      "button",
                      {
                        staticClass: "close-button",
                        on: {
                          click: function($event) {
                            return _vm.$emit("should-close")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "close-button-icon",
                          attrs: {
                            src:
                              "/site_media/version-c31a9cd477/images/home/close-button-icon.png",
                            alt: "Close modal"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "streak-info" },
                  [
                    _c("StreakCount", {
                      attrs: {
                        "current-streak": _vm.currentStreak,
                        progress: _vm.completedTodaysStreak
                          ? 1
                          : _vm.streakProgress,
                        size: _vm.streakCountSize
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-header",
                        attrs: { "data-testid": "streak_popup_sub_header" }
                      },
                      [
                        _vm.completedTodaysStreak || _vm.streakProgress === 1
                          ? _c("h3", [
                              _vm._v(
                                "\n            You're on a " +
                                  _vm._s(_vm.currentStreak) +
                                  "-day streak!\n          "
                              )
                            ])
                          : _vm.showStreakDetails
                          ? [
                              _vm.notificationType === "none" ||
                              _vm.notificationType === "newuser"
                                ? _c("p", [
                                    _vm._v(
                                      "\n              Solve\n              "
                                    ),
                                    _c("span", { staticClass: "problems" }, [
                                      _vm._v(
                                        _vm._s(_vm.problemsLeftForStreak) +
                                          "\n                " +
                                          _vm._s(
                                            _vm.problemsSolvedInCurrentStreak >
                                              0
                                              ? " more"
                                              : ""
                                          )
                                      )
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.problemsLeftForStreak == 1
                                            ? "problem"
                                            : "problems"
                                        ) +
                                        " to\n              " +
                                        _vm._s(_vm.streakDetailsVerb) +
                                        " a streak.\n            "
                                    )
                                  ])
                                : _vm.notificationType === "newstreak"
                                ? _c("p", [
                                    _vm._v("\n              Solve "),
                                    _c("span", { staticClass: "problems" }, [
                                      _vm._v(_vm._s(_vm.problemsRequiredPerDay))
                                    ]),
                                    _vm._v(
                                      " problems daily to\n              build your streak.\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isStreakChargesEnabled
                          ? _c("StreakChargesIndicator", {
                              staticClass: "streak-charges-indicator",
                              attrs: {
                                "max-num-streak-charges":
                                  _vm.maxNumStreakCharges,
                                "num-available-streak-charges":
                                  _vm.numAvailableStreakCharges
                              }
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.hideCalendar
                  ? _c(
                      "div",
                      { staticClass: "calendar-wrapper" },
                      [
                        _c("StreakCalendar", {
                          attrs: {
                            "calendar-days": _vm.calendarDays,
                            narrow: !_vm.isMobile
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMobile
                  ? _c(
                      "button",
                      {
                        staticClass: "btn got-it-button",
                        on: {
                          click: function($event) {
                            return _vm.$emit("should-close")
                          }
                        }
                      },
                      [_vm._v("\n        Continue\n      ")]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }